/**
 * 用户
**/

import {http} from '@/server/meetHttpServer.js'

// 验证手机验证码是否正确
export const checkValidCode = (data) => {
    return http({ url:'/pisces/user/checkValidCode'}, data)
}

// 获取秘钥信息
export const getPublicKey = (data) => {
    return http({url: '/pisces/user/getPublicKey' }, data)
}

// 获取短信验证码
export const getSMSCode = (data) => {
    return http({ url: '/pisces/user/getSMSCode' }, data)
}

// 刷新token
export const refreshToken = (data) => {
    return http({ url: '/pisces/user/refreshToken' }, data)
}

// 找回密码
export const resetUserPassWord = (data) => {
    return http({ url: '/pisces/user/resetUserPassWord' }, data)
}

// 查询普通用户
export const searchCommonUser = (data) => {
    return http({ url: '/pisces/user/searchCommonUser' }, data)
}

// 用户通过验证码登录
export const userLoginByCode = (data) => {
    return http({ url: '/pisces/user/userLoginByCode' }, data)
}

// 用户通过验证码登录
export const userLoginBySMSCode = (data) => {
    return http({ url: '/pisces/user/userLoginBySMSCode' }, data)
}

// 用户通过手机号登录
export const userLoginByMobile = (data) => {
    return http({ url: '/pisces/user/userLoginByMobile' }, data)
}

// 修改密码
export const updatePassword = (data) => {
    return http({ url: '/pisces/user/updatePassword' }, data)
}
// 庭审列表
export const getMeetingList = (data) => {
    return http({ url:'/pisces/meeting/getMeetingList'}, data)
}

// 庭审数量
export const getMeetingCount = (data) => {
    return http({ url:'/pisces/meeting/getMeetingCount'}, data)
}

// 调解室列表
export const queryMediationRoom = (data) => {
    return http({ url:'/pisces/mediationRoom/queryMediationRoom'}, data)
}

// 显示实名认证二维码
export const showRealNameVerifyQRCode = (data) => {
    return http({ url: '/pisces/user/showRealNameVerifyQRCode', method: 'get' }, data)
}

// 获取实时实名认证状态
export const getRealNameVerifyStatus = (data) => {
    return http({ url: '/pisces/user/getRealNameVerifyStatus' }, data)
}

// 获取个人签名、预留邮箱
export const getUserSignAndEmail = (data) => {
    return http({ url: '/scavenger/signature/getUserSignAndEmail', method: 'get' }, data)
}

/* 案件（调解室）统计数量（进行中，已结束） */
export const countMediationRoomByStatus = (data) => {
    return http({
        url: '/pisces/mediationRoom/countMediationRoomByStatus',
        method: 'post'
    }, data)
}

/* 案件监管数据统计 */
export const allMediationRoomStatistics = (data) => {
    return http({
        url: '/pisces/mediationRoom/allMediationRoomStatistics',
        method: 'post'
    }, data)
}

/* 新增机构详情 */
export const addBackstageOrganization = (data) => {
    return http({
        url: '/pisces/backstageOrganization/addBackstageOrganization',
        method: 'post'
    }, data)
}

/* 机构列表 */
export const getOrganizationList = (data) => {
    return http({
        url: '/pisces/backstageOrganization/getOrganizationList',
        method: 'post'
    }, data)
}

/* 查询后台机构信息列表 */
export const listBackstageOrganization = (data) => {
    return http({
        url: '/pisces/backstageOrganization/listBackstageOrganization',
        method: 'post'
    }, data)
}

/* 机构详情 */
export const searchBackstageOrganization = (data) => {
    return http({
        url: '/pisces/backstageOrganization/searchBackstageOrganization',
        method: 'post'
    }, data)
}

/* 编辑机构信息 */
export const updateBackstageOrganization = (data) => {
    return http({
        url: '/pisces/backstageOrganization/updateBackstageOrganization',
        method: 'post'
    }, data)
}

/* 更新机构状态 */
export const updateBackstageOrganizationStatus = (data) => {
    return http({
        url: '/pisces/backstageOrganization/updateBackstageOrganizationStatus',
        method: 'post'
    }, data)
}

/* 材料质证列表 */
export const evidenceList = (data) => {
    return http({
        url: '/gzzc/attachmentEvidence/evidenceList',
        method: 'post'
    }, data)
}

/* 点击质证创建房间 */
export const createRoom = (data) => {
    return http({
        url: '/gzzc/attachmentEvidence/createRoom',
        method: 'post'
    }, data)
}

/* 提交质证 */
export const addEvidence = (data) => {
    return http({
        url: '/gzzc/attachmentEvidence/submitEvidence',
        method: 'post'
    }, data)
}

/* 查询材料列表支持案件或会议 */
export const queryLawAttachmentList = (data) => {
    return http({
        url: '/gzzc/docBook/queryLawAttachmentList',
        method: 'post'
    }, data)
}

/* 材料保存（业务-上传） */
export const saveAttachmentUpload = (data) => {
    return http({
        url: '/gzzc/docBook/saveAttachmentUpload',
        method: 'post'
    }, data)
}

/* 查询后台人员列表 */
export const listBackstageUser = (data) => {
    return http({
        url: '/scavenger/backstageUser/listBackstageUser',
        method: 'post'
    }, data)
}

/* 更新工作人员状态 */
export const updateBackstageUserStatus = (data) => {
    return http({
        url: '/pisces/backstageUser/updateBackstageUserStatus',
        method: 'post'
    }, data)
}

/* 添加工作人员 */
export const insertBackstageUser = (data) => {
    return http({
        url: '/pisces/backstageUser/insertBackstageUser',
        method: 'post'
    }, data)
}

/* 查询工作人员详情 */
export const searchBackstageUser = (data) => {
    return http({
        url: '/pisces/backstageUser/searchBackstageUser',
        method: 'post'
    }, data)
}

/* 修改工作人员详情 */
export const updateBackstageUser = (data) => {
    return http({
        url: '/pisces/backstageUser/updateBackstageUser',
        method: 'post'
    }, data)
}

/* 查询业务人员角色 */
export const searchBizUserRole = (data) => {
    return http({
        url: '/pisces/role/searchBizUserRole',
        method: 'post'
    }, data)
}

/* 获取平台信息 */
export const getOrgInfoList = (data) => {
    return http({
        url: '/pisces/platform/getOrgInfoList',
        method: 'post'
    }, data)
}

/* 编辑水印信息 */
export const editWatermark = (data) => {
    return http({
        url: '/pisces/platform/editWatermark',
        method: 'post'
    }, data)
}

/* 获取水印信息 */
export const getWatermark = (data) => {
    return http({
        url: '/pisces/platform/getWatermark',
        method: 'post'
    }, data)
}

/* 查询工作人员角色 */
export const searchWorkUserRole = (data) => {
    return http({
        url: '/pisces/role/searchWorkUserRole',
        method: 'post'
    }, data)
}

/* 获取Banner信息 */
export const getBannerList = (data) => {
    return http({
        url: '/pisces/platform/getBannerList',
        method: 'post'
    }, data)
}

/* 案件材料删除 */
export const delMediationMaterial = (data) => {
    return http({
        url: '/gzzc/docBook/delMediationMaterial',
        method: 'post'
    }, data)
}

/* 删除质证 */
export const delEvidence = (data) => {
    return http({
        url: '/gzzc/attachmentEvidence/deleteEvidence',
        method: 'post'
    }, data)
}
/*  删除证据列表项 */ 
export const delEvidenceDetails= (data) => {
    return http({
        url: '/gzzc/docBook/delEvidenceDetails',
        method: 'post'
    }, data)
}
/*  举证质证导入接口 */
export const importProof= (data) => {
    return http({
        url: '/scavenger/docBook/importProof',
        method: 'post'
    }, data)
}

